import Banner from '../../components/Landing/template3/Banner';
import Header from '../../components/Landing/template4/HeaderWithModules';
import DemoForm from '../../components/Landing/template4/DemoForm';
import ScheduleDemo from '../../components/Landing/template4/SchaduleDemo';
import CustomHTML from '../../components/Landing/template4/CustomHTML';

const componentMap = {
  Banner,
  Header,
  DemoForm,
  ScheduleDemo,
  CustomHTML,
};


const Components = (props) => {
  const { cName, template, selectLanguage, ...restProps } = props;
  
  if (props.cName === 'Modules' && Modules) {
    return <Modules {...props} />
  }
  
  if(props?.template == 4){
    const SelectedComponent = componentMap[cName] || null;
    return SelectedComponent ? <SelectedComponent {...restProps} selectLanguage={selectLanguage} /> : <div />;
  }else{
    let Header, Banner, DemoForm, BannerBottom, Card, Features, Clients, Modules, Faqs, Testimonial, ScheduleDemo, CustomHTML, CustomHTML_1, CustomHTML_2, CustomHTML_3;  
    switch (props?.template) {
      case 1:
        Banner = dynamic(()=>import(`../../components/Landing/template1/Banner`))
        BannerBottom = dynamic(()=>import('../../components/Landing/template1/BannerBottom'))
        Card = dynamic(()=>import(`../../components/Landing/template1/Card`))
        Features = dynamic(()=>import(`../../components/Landing/template1/Features`))
        Clients = dynamic(()=>import(`../../components/Landing/template1/Clients`))
        Modules = dynamic(()=>import('../../components/Landing/template1/Modules'))
        Faqs = dynamic(()=>import('../../components/Landing/template1/Faqs'))
        Testimonial = dynamic(()=>import('../../components/Landing/template1/Testimonial'))
        ScheduleDemo = dynamic(()=>import('../../components/Landing/template1/SchaduleDemo'))
        CustomHTML_1 = dynamic(()=>import('../../components/Landing/template1/CustomHTML_1'))
        CustomHTML_2 = dynamic(()=>import('../../components/Landing/template1/CustomHTML_2'))
        CustomHTML_3 = dynamic(()=>import('../../components/Landing/template1/CustomHTML_3'))
        break
      case 2:
        Banner = dynamic(() => import(`../../components/Landing/template2/Banner`))
        BannerBottom = dynamic(() => import('../../components/Landing/template2/BannerBottom'))
        Card = dynamic(() => import(`../../components/Landing/template2/Card`))
        Features = dynamic(() => import(`../../components/Landing/template2/Features`))
        Clients = dynamic(() => import(`../../components/Landing/template2/Clients`))
        Modules = dynamic(() => import('../../components/Landing/template2/Modules'))
        // Faqs = dynamic(() => import('../../components/Landing/template2/Faqs'))
        Testimonial = dynamic(() => import('../../components/Landing/template2/Testimonial'))
        ScheduleDemo = dynamic(() => import('../../components/Landing/template2/SchaduleDemo'))
        CustomHTML_1 = dynamic(() => import('../../components/Landing/template2/CustomHTML_1'))
        CustomHTML_2 = dynamic(() => import('../../components/Landing/template2/CustomHTML_2'))
        CustomHTML_3 = dynamic(() => import('../../components/Landing/template2/CustomHTML_3'))
        break
      case 3:
        Banner = dynamic(()=>import(`../../components/Landing/template3/Banner`))
        BannerBottom = dynamic(()=>import('../../components/Landing/template3/BannerBottom'))
        Card = dynamic(()=>import(`../../components/Landing/template3/Card`))
        Features = dynamic(()=>import(`../../components/Landing/template3/Features`))
        Clients = dynamic(()=>import(`../../components/Landing/template3/Clients`))
        Modules = dynamic(()=>import('../../components/Landing/template3/Modules'))
        Faqs = dynamic(()=>import('../../components/Landing/template3/Faqs'))
        Testimonial = dynamic(()=>import('../../components/Landing/template3/Testimonial'))
        ScheduleDemo = dynamic(()=>import('../../components/Landing/template3/SchaduleDemo'))
        CustomHTML_1 = dynamic(()=>import('../../components/Landing/template3/CustomHTML_1'))
        CustomHTML_2 = dynamic(()=>import('../../components/Landing/template3/CustomHTML_2'))
        CustomHTML_3 = dynamic(()=>import('../../components/Landing/template3/CustomHTML_3'))
        break
        default:
          return {};
    }
    const componentList = {
      Header,
      Banner,
      DemoForm,
      BannerBottom,
      Clients,
      Intro,
      WhyWebHR,
      SeeActions,
      ScheduleDemo,
      Card,
      Features,
      Testimonial,
      AI,
      OldNew,
      Section,
      TagLine,
      Faqs,
      CustomHTML,
      CustomHTML_1,
      CustomHTML_2,
      CustomHTML_3,
    }
  
    const ComponentName = componentList[props.cName]
    return ComponentName ? <ComponentName {...props} selectLanguage={props.selectLanguage} /> : <div></div>
  }
};


export default Components;
